import { Inject, Injectable } from '@angular/core'
import { PasswordService } from '../../shared/services/password.service'
import { AuthControllerService, LoginResponse, UsersControllerService } from '../../api/auth'
import { AppProjectControllerService, ProjectResponseDto } from '../../api/backend'
import { Observable, firstValueFrom } from 'rxjs'

@Injectable({
    providedIn: 'root'
})
export class AuthBackendService {

    constructor(@Inject(AppProjectControllerService) private appProjectControllerService: AppProjectControllerService,
                @Inject(AuthControllerService) private authControllerService: AuthControllerService,
                @Inject(PasswordService) private passwordService: PasswordService,
                @Inject(UsersControllerService) private usersControllerService: UsersControllerService,
                ) {
    }

    refreshAccessToken(projectKey): Promise<LoginResponse> {
        return firstValueFrom(this.authControllerService.refreshAccessToken({}, projectKey))
    }

    login(username, password, keep): Observable<LoginResponse> {
        const passwordEncoded = this.passwordService.hashPassword(password, username)

        return this.authControllerService.login({
            username: username,
            password: passwordEncoded,
            keep: keep
        })
    }

    changePassword(username, oldPassword, newPassword): Promise<any> {
        const oldPasswordEncoded = this.passwordService.hashPassword(oldPassword, username)
        const newPasswordEncoded = this.passwordService.hashPassword(newPassword, username)

        return firstValueFrom(this.usersControllerService.changePassword({
            username: username,
            password: oldPasswordEncoded,
            newPassword: newPasswordEncoded
        }))
    }

    logout(): Observable<any> {
        return this.authControllerService.logout()
    }

    changeDefaultProjectKey(projectKey): Promise<any> {
        return firstValueFrom(this.usersControllerService.changeDefaultProjectKey(projectKey))
    }

    getProjectByAuthorizationToken(): Promise<ProjectResponseDto> {
        return firstValueFrom(this.appProjectControllerService.getProjectFromAuthorizationToken())
    }

    getProjects(projectKeys: Array<string>): Observable<ProjectResponseDto[]> {
        return this.appProjectControllerService.getProjectsByKeys(projectKeys)
    }

    getUserProjectKeys(): Promise<Array<string>> {
        return firstValueFrom(this.usersControllerService.getProjects())
    }
}
